import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatTime', (date) => {
  if (date) {
    return moment(date).format('hh:mm a');
  } else {
    return 'n/a';
  }
});

Vue.filter('formatDate', (date) => {
  if (date) {
    return moment(date).format('MMM DD');
  } else {
    return 'n/a';
  }
});

Vue.filter('formatDateYear', (date) => {
  if (date) {
    return moment(date).format('MMM DD, YYYY');
  } else {
    return 'n/a';
  }
});

Vue.filter('formatDateTime', (date) => {
  if (date) {
    return moment(date).format('MMM DD hh:mm a');
  } else {
    return 'n/a';
  }
});

Vue.filter('formatNumber', (val) => {
  if (val) {
    return val.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return '0';
  }
});

Vue.filter('percent', (val) => {
  if (val && !isNaN(val)) {
    return `${Math.ceil(val * 100).toFixed(0)}%`;
  } else {
    return val;
  }
});
